/**
 * Export switchImages function to use it in othesr files
 *
 */
export const switchImages = () => {

	/**
	 * Check if is mobile screen
	 *
	 * @return {boolean}
	 */
	const isMobile = () => {

		if ( window.matchMedia( '(max-width: 991px)' ).matches ) {

			return true;

		}
		return false;

	}

	/**
	 * Observe images
	 *
	 * @return {object} observer options
	 */
	const observerOptions = () => {

		if ( isMobile ) {

			return {
				root: null,
				rootMargin: '300px',
				threshold: 0,
			}

		}

		return {
			root: null,
			rootMargin: '700px',
			threshold: 0,
		}

	}

	/**
	 * Lazy load images
	 */
	const lazyLoadImages = () => {

		const images = document.querySelectorAll( '.wombat-lazy-load' );

		const observer = new IntersectionObserver( ( entries ) => {

			entries.forEach( ( entry ) => {

				if ( entry.isIntersecting && entry.target.classList.contains( 'wombat-lazy-load' ) ) {

					const src = entry.target.dataset.src;
					const srcset = entry.target.dataset.srcset;
					entry.target.setAttribute( 'src', src );
					entry.target.setAttribute( 'srcset', srcset );
					entry.target.classList.remove( 'wombat-lazy-load' );

					if ( srcset ) {

						entry.target.setAttribute( 'srcset', srcset );

					} else {

						entry.target.removeAttribute( 'srcset' );

					}

				}

			} );

		}, observerOptions() );

		images.forEach( ( sections ) => {

			observer.observe( sections );

		} );

	}

	lazyLoadImages();

}

window.addEventListener( 'DOMContentLoaded', () => {

	switchImages();

} );
